import { exhaustiveGuard, isDefined } from './types';

function canLog(): boolean {
  return isDefined(console);
}

function getLogParamsFromQueryString(): string[] | null {
  return new URLSearchParams(window.location.search).getAll('log');
}

interface LogOptions {
  title: string;
  context?: unknown[];
  level?: 'info' | 'warn' | 'error';
}
export function log({ title, context, level }: LogOptions): void {
  const logParams = getLogParamsFromQueryString();

  if (!canLog() || logParams === null || logParams.length === 0) {
    return;
  }

  const hasWildcardLogParam = logParams.some(
    (logParam) => logParam.length === 0
  );
  const hasTitleMatchingLogParam = logParams.includes(title);

  if (hasWildcardLogParam || hasTitleMatchingLogParam) {
    context = context ?? [];
    level = level ?? 'info';

    switch (level) {
      case 'info':
        // eslint-disable-next-line no-console
        console.log(title, ...context);
        break;

      case 'warn':
        console.warn(title, ...context);
        break;

      case 'error':
        console.error(title, ...context);
        break;

      default:
        exhaustiveGuard(level, 'Invalid logging level');
    }
  }
}
